import React from "react";

import "./Swimlane.scss";

export const SwimlaneItem = ({ heading, children }) => {
  return (
    <div className="Swimlane__Item">
      <div className="Swimlane__Item__Header">{heading}</div>
      <div className="Swimlane__Item__Children">{children}</div>
    </div>
  );
};

export type SwimlaneProps = {
  heading?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
};
const Swimlane = ({ children }: SwimlaneProps) => {
  return <div className="Swimlane">{children}</div>;
};

Swimlane.displayName = "Swimlane";

export default Swimlane;
